import './Wrapper.scss'
import React from 'react'
import { Row } from 'antd'

function Wrapper({ children }) {
	return (
		<Row className="stakeholder-layout-wrapper">
			{ children }
		</Row>
	)
}

export default Wrapper
